export enum TransactionValueEnteredInEnum {
  MNE = 1,
  Source,
  Destination,
}
